import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollToTop() {
	const { pathname } = useLocation();
	const navigationType = useNavigationType();

	useEffect(() => {
		// A6 — only scroll to top on NEW navigations (PUSH/REPLACE). On POP
		// (browser back/forward) we let the browser restore the previous scroll
		// position instead of dumping the user at the top.
		if (navigationType === 'POP') return;

		// "document.documentElement.scrollTo" is the magic for React Router Dom v6
		document.documentElement.scrollTo({
			top: 0,
			left: 0,
			behavior: 'instant', // Optional if you want to skip the scrolling animation
		});
	}, [pathname, navigationType]);

	return null;
}
